import React from 'react';
import notFound from '../../assets/icons/new_icon/404.svg';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
const UnauthorizedPage = () => {
  const { userData } = useSelector((state: RootState) => state.mainAppData);
  const isVendor = userData?.is_vendor;
  return (
    <div className='d-flex mt-5 flex-column m-auto justify-content-center align-items-center'>
      <div className='mb-1 mt-4'>
        <img
          src={notFound}
          alt=''
        />
      </div>
      <h1 className='rates__title mt-4'>Page not Found!</h1>
      <p className='lex-black-18-300 text-center mb-1'>
        Apologies for the inconvenience.
      </p>
      <p className='lex-black-18-300 text-center '>
        Please verify the URL or return to the homepage
      </p>
      <Link
        to={`${isVendor ? '/app/ship-now' : '/app/dashboard'}`}
        className='btn btn-ubbe-blue lex-black-18-300 mt-2 align-content-center '
        style={{ fontWeight: '400', height: '48px' }}
      >
        Go Back
      </Link>
    </div>
  );
};

export default UnauthorizedPage;
